import { render, staticRenderFns } from "./ReceiptReportComponent.vue?vue&type=template&id=38434536&scoped=true&"
import script from "./ReceiptReportComponent.vue?vue&type=script&lang=js&"
export * from "./ReceiptReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptReportComponent.vue?vue&type=style&index=0&id=38434536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38434536",
  null
  
)

export default component.exports